import styled from "@emotion/styled";

export const PageContainer = styled.div`
  width: 100%;
  padding: 32px;
  background-color: #f9fafb; /* gray-50 */
  min-height: 100vh;
  box-sizing: border-box;
`;

export const StepperWrapper = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  margin-bottom: 24px;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #111827; /* gray-900 */
  margin: 0;
`;

export const StatusDot = styled.span<{ status?: string }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 13px;
  font-weight: 500;
  text-transform: capitalize;

  ${(props) => {
    const s = props.status?.toLowerCase() || "";
    if (s.includes("delivered") || s.includes("completed")) {
      return `background: #ecfdf5; color: #047857;`; // green
    }
    if (s.includes("cancelled") || s.includes("rejected")) {
      return `background: #fef2f2; color: #b91c1c;`; // red
    }
    if (s.includes("processing") || s.includes("confirmed")) {
      return `background: #eff6ff; color: #1d4ed8;`; // blue
    }
    if (s.includes("shipped") || s.includes("out for")) {
      return `background: #fff7ed; color: #ea580c;`; // orange
    }
    return `background: #f3f4f6; color: #374151;`; // gray
  }}

  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 6px;
    background-color: currentColor;
    opacity: 0.8;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 12px;
`;

export const ActionButton = styled.button<{
  variant?: "primary" | "secondary" | "danger";
}>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;

  ${(props) => {
    switch (props.variant) {
      case "primary":
        return `
                background: #111827;
                color: white;
                border: 1px solid #111827;
                &:hover { background: #1f2937; }
                &:disabled { opacity: 0.6; cursor: not-allowed; }
            `;
      case "danger":
        return `
                background: white;
                color: #ef4444;
                border: 1px solid #fee2e2;
                &:hover { background: #fef2f2; border-color: #fecaca; }
            `;
      case "secondary":
      default:
        return `
                background: white;
                color: #374151;
                border: 1px solid #e5e7eb;
                &:hover { background: #f9fafb; border-color: #d1d5db; }
            `;
    }
  }}
`;

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

// --- Card Components ---
export const Card = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.05),
    0 1px 2px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border: 1px solid #f3f4f6;
  display: flex;
  flex-direction: column;
`;

export const CardHeader = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
`;

export const CardTitle = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CardContent = styled.div`
  padding: 20px;
`;

// --- Typography ---
export const Label = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 4px;
  display: block;
`;

export const Value = styled.span`
  font-size: 14px;
  color: #111827;
  font-weight: 500;
  word-break: break-word; /* Ensure long values don't overflow */
`;
